import { l } from '../../lib/imports'
import { stringUtils } from '../../lib/stringUtils-sidecar'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { EInfoRequestType } from './multi/voyageMessageInfoRequest'
import { voyageMessageInfoRequest } from './multi/voyageMessageInfoRequest-sidecar'

import { voyageCamera } from './voyageCamera-sidecar'
import { EVoyageCrewType } from './voyageCrew'
import { voyageLayers } from './voyageLayers-sidecar'
import { voyagePicker } from './voyagePicker-sidecar'
import { voyageTestParams } from './voyageTestParams-sidecar'
import { EVoyageTile } from './voyageTileData'
import type { IVoyageUiCanvas } from './voyageUiCanvas'
import { voyageUiCanvas } from './voyageUiCanvas-sidecar'
import { voyageUiGraphicsUtils } from './voyageUiGraphicsUtils-sidecar'

export interface IVoyageUiInfoBar extends IVoyageUiCanvas {
  //slot: number
  //hoveredPart: IGoatShipPart | null
}

const _showIds = false && voyageTestParams.isDevMode

let _obj: IVoyageUiCanvas | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setOpen(true)
  }
  return _obj
}
const create = () => {
  let tw = 0
  let th = 0
  let canvas = voyageUiCanvas.create(tw, th, voyageLayers.getLayers().uiGame)
  canvas.autoOffset = false

  let obj: IVoyageUiCanvas = voyageUiCanvas.assign<IVoyageUiInfoBar>(canvas, {
    //slot: 1,
    //hoveredPart: null,
  })

  return obj
}

export const setOpen = (isOpen: boolean) => {
  let obj = get()
  voyageUiCanvas.setOpen(obj, isOpen)
}

export const render = () => {
  let obj = get()
  let g = obj.graphics

  voyageUiCanvas.clear(obj)

  let gb = voyageCamera.getGameBounds()

  let x = 60
  let y = 60

  // let w = gb.width - 150 * 2
  // let h = 200
  // x = 150
  // y = gb.height - h - 20
  let w = 500
  let h = 300
  let sy = y
  let sx = x

  let addText = (text: string, ox: number = 0, oy: number = 0) => {
    let t = voyageUiCanvas.addText(obj, text, x + ox, y + oy, 3)
    stevieTexts2.setWrapWidth(t, w - 60)
    let ch = stevieTexts2.getCurrentHeight(t)
    if (ch < 20) {
      ch = 20
    }
    y += ch
    return t
  }

  let addSpacer = () => {
    y += 30
  }

  // goatGraphicsUtils.bevelPanelBackground(g, x, y, w, h)

  let vp = voyagePicker.get()
  let cr = vp.hoveredCrew || vp.selectedCrew
  let sysTile = vp.hoveredSystem
  let items = (vp.hoveredTile && vp.hoveredTile.items) || []

  let hoveredText = ''
  if (vp.hoveredTile) {
    if (vp.hoveredTile.tile2.type === EVoyageTile.Chair) {
      hoveredText += 'Chair or Torpedo'
    }
    if (vp.hoveredTile.tile2.type === EVoyageTile.Table) {
      hoveredText += 'Table or Console'
    }
  }

  let doShowInfoBar = cr || sysTile || hoveredText || items.length > 0

  if (doShowInfoBar) {
    // voyageUiGraphicsUtils.bevelPanel2(g, x, y, w, h)
    //voyageUiGraphicsUtils.bevelPanelBackground(g, x, y, w, h, 16, 0)
    //voyageUiGraphicsUtils.bevelPanelOutline(g, x, y, w, h, 16, 0)

    addText('Info-matic 2000', 6, 0)
    y += 10
    x += 30
  }

  if (cr) {
    if (_showIds) {
      addText('ID: ' + cr.id)
    }

    if (cr.type === EVoyageCrewType.Crew) {
      addText('Crew Member')
      if (!cr.requestedInfo) {
        voyageMessageInfoRequest.sendMessageRequest({
          type: EInfoRequestType.Crew,
          crewId: cr.id,
          systemKey: '',
        })
      }
    }
    if (cr.type === EVoyageCrewType.Alien) {
      addText('Alien')
    }
    if (cr.type === EVoyageCrewType.Fire) {
      addText('FIRE!')
      addSpacer()
      addText('Eats oxygen and spreads over time')
      addSpacer()
      addText('Move crew next to extinguish')
    }

    if (cr.type === EVoyageCrewType.HullBreach) {
      addText('Hull Breach!')
      addSpacer()
      addText('Leaks oxygen and gets bigger over time')
      addSpacer()
      addText('Move crew next to repair')
    }

    addSpacer()

    addText(cr.name)

    if (cr.title) {
      addText(cr.title)
    }

    addSpacer()
    //addText(cr.i + ',' + cr.j)
    addText('Health ' + stringUtils.formatInteger(cr.hitpoints))

    if (cr.type === EVoyageCrewType.Crew) {
      addText('Energy ' + stringUtils.formatInteger(cr.energy))
      if (cr.isPassedOut) {
        addText('Passed out from lack of sleep!')
      }
      if (cr.crewState) {
        addSpacer()

        const addStat = (label: string, val: number) => {
          if (val) {
            addText(label + ': ' + stringUtils.formatInteger(val))
          }
        }

        addStat('Kills', cr.crewState.statKills)
        addStat('Damage dealt', cr.crewState.statDamageGiven)
        addStat('Heals given', cr.crewState.statHeals)
        addStat('Repairs made', cr.crewState.statRepairs)
        addStat('Fires fought', cr.crewState.statFiresFought)
      }
    }

    addSpacer()
    addText(cr.info1)
    addSpacer()
    addSpacer()
  }

  if (sysTile) {
    // addSpacer()

    //let sys = voyageTilemap.getSystemSafe(sysTile)
    if (sysTile && sysTile.system) {
      let sys = sysTile.system
      addText(sys.data.name)
      if (_showIds) {
        addText('ID: ' + sys.id)
      }
      addSpacer()
      addText('Subsystem (move crew here to use)')
      //addText(sysTile)

      addSpacer()

      if (!sys.requestedInfo) {
        voyageMessageInfoRequest.sendMessageRequest({
          type: EInfoRequestType.System,
          crewId: 0,
          systemKey: sys.key,
        })
      }

      if (!sys.nickname) {
        addText('Fetching bio...')
      } else {
        addText("Nicknamed '" + sys.nickname + "'")
      }

      addSpacer()
      addText(sys.data.infoText)

      // if (sys.text3.startsWith('crematorium')) {
      //   addSpacer()
      //   addText('In space, no one can hear you scream.')
      //   addSpacer()
      //   addText('Trying to find a safe way to dispose of dead bodies?')
      //   addSpacer()
      //   addText('In space, no one can. Here, use crematorium.')
      //   addSpacer()
      // }

      if (sys.data.extraInfo) {
        addSpacer()
        addSpacer()
        addText(sys.data.extraInfo(sysTile))
      }

      addSpacer()
    } else {
      addText(sysTile.text3)

      addSpacer()
    }

    addSpacer()
    // addText(sys.info1)
    addSpacer()
  }
  if (hoveredText) {
    addText(hoveredText)
    addSpacer()
  }

  if (items.length > 0) {
    l.forEach(items, (c) => {
      addSpacer()
      addText('Item here: ' + c.data.name)
      if (_showIds) {
        addText('ID: ' + c.id)
      }
      addSpacer()
      addText(c.data.info)
      addSpacer()
    })
  }

  if (doShowInfoBar) {
    if (y > h) {
      h = y + 50
    }
    voyageUiGraphicsUtils.bevelPanel2(g, sx, sy, w, h)
  }

  // goatUiFreeBuild_tooltipPart.render(obj)

  voyageUiCanvas.render(obj)
}

export const update = () => {
  let obj = get()
  if (obj.isOpen) {
    voyageUiCanvas.update(obj)
    render()
  }
}
